import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../../../../config/AppConfig";
import {AppIconThumbnail} from "../../../../../components/BaseComponents/AppIconThumbnail";

export default class LeaveRequestListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getStatusLabel = status => {
        switch (status) {
            case "approved":
                return {label: "Approvato", className: "badge badge-success"};
            case "rejected":
                return {label: "Rifiutato", className: "badge badge-danger"};
            case "waiting_approval":
            default:
                return {label: "In attesa", className: "badge badge-warning"};
        }
    }

    getAttachmentsLabel = count => {
        const attachmentsCount = parseInt(count, 10);
        if (!attachmentsCount) return null;
        return attachmentsCount === 1 ? "1 allegato" : `${attachmentsCount} allegati`;
    }

    handleOpenClick = _ => {
        if (this.props.onOpen) {
            this.props.onOpen(this.props.item);
        }
    }

    render() {
        const item = this.props.item || {};
        const staff = this.props.staff || {};
        const statusInfo = this.getStatusLabel(item.status);
        const startDate = moment(item.data_inizio).format("DD/MM/YYYY");
        const endDate = moment(item.data_fine).format("DD/MM/YYYY");
        let dateRange = "-";

        if (startDate === endDate) {
            dateRange = startDate;
        } else {
            dateRange = `${startDate} - ${endDate}`;
        }

        const attachmentsLabel = this.getAttachmentsLabel(item.attachments_count);
        const metaLine = (attachmentsLabel ? `${dateRange} - ${attachmentsLabel}` : dateRange) + (item.total_hours && parseFloat(item.total_hours) > 0 ? ` | ${item.total_hours} h` : '');
        const negozio = staff.negozio || item.negozio || null;
        const negozioIconUrl = negozio?.id_negozio
            ? `${AppConfig.webServerUrl}/api/negozio/${negozio.id_negozio}/logoIcon/50`
            : null;
        return (
            <div className={"list-group-item list-group-item-action"} onClick={this.handleOpenClick}>
                <div className={"d-flex justify-content-between align-items-start"}>
                    <div className={"d-flex align-items-center"}>
                        <AppIconThumbnail size={"32px"} src={negozioIconUrl} className={"mr-2"}/>
                        <div className={"font-weight-bold"}>{negozio?.nome || "Attivita'"}</div>
                    </div>
                    <span className={statusInfo.className}>{statusInfo.label}</span>
                </div>
                <div className={"text-muted small mt-1"}>
                    {metaLine}

                </div>
            </div>
        );
    }
}

LeaveRequestListItem.propTypes = {
    item: PropTypes.object,
    staff: PropTypes.object,
    onOpen: PropTypes.func
};
